// ------------------------------------------------------------------------------
// name: countries
// author: mudas
// created: 2025/3/30
// ------------------------------------------------------------------------------

export interface CountryPhoneType {
  name: string;
  nameCN: string;
  iso2: string;
  dialCode: string;
  priority: number;
  areaCodes: string[] | null;
  pinyin: string;
}

/**
 * 全球国家列表
 */
export const GlobalCountries: CountryPhoneType[] = [
  {
    name: 'China (中国)',
    nameCN: '中国',
    iso2: 'cn',
    dialCode: '86',
    priority: 0,
    areaCodes: null,
    pinyin: 'Z',
  },
  {
    name: 'Hong Kong (中国香港)',
    nameCN: '中国香港',
    iso2: 'hk',
    dialCode: '852',
    priority: 0,
    areaCodes: null,
    pinyin: 'Z',
  },
  {
    name: 'Macau (中国澳门)',
    nameCN: '中国澳门',
    iso2: 'mo',
    dialCode: '853',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Taiwan (中国台灣)',
    nameCN: '中国台湾',
    iso2: 'tw',
    dialCode: '886',
    priority: 0,
    areaCodes: null,
    pinyin: 'Z',
  },
  {
    name: 'Afghanistan (‫افغانستان‬‎)',
    nameCN: '阿富汗',
    iso2: 'af',
    dialCode: '93',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Albania (Shqipëri)',
    nameCN: '阿尔巴尼亚',
    iso2: 'al',
    dialCode: '355',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Algeria (‫الجزائر‬‎)',
    nameCN: '阿尔及利亚',
    iso2: 'dz',
    dialCode: '213',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'American Samoa',
    nameCN: '美属萨摩亚群岛',
    iso2: 'as',
    dialCode: '1684',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Andorra',
    nameCN: '安道尔',
    iso2: 'ad',
    dialCode: '376',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Angola',
    nameCN: '安哥拉共和国',
    iso2: 'ao',
    dialCode: '244',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Anguilla',
    nameCN: '安圭拉',
    iso2: 'ai',
    dialCode: '1264',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Antigua and Barbuda',
    nameCN: '安提瓜岛',
    iso2: 'ag',
    dialCode: '1268',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Argentina',
    nameCN: '阿根廷',
    iso2: 'ar',
    dialCode: '54',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Armenia (Հայաստան)',
    nameCN: '亚美尼亚',
    iso2: 'am',
    dialCode: '374',
    priority: 0,
    areaCodes: null,
    pinyin: 'Y',
  },
  {
    name: 'Aruba',
    nameCN: '阿鲁巴',
    iso2: 'aw',
    dialCode: '297',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Australia',
    nameCN: '澳大利亚',
    iso2: 'au',
    dialCode: '61',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Austria (Österreich)',
    nameCN: '奥地利共和国',
    iso2: 'at',
    dialCode: '43',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Azerbaijan (Azərbaycan)',
    nameCN: '阿塞拜疆共和国',
    iso2: 'az',
    dialCode: '994',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Bahamas',
    nameCN: '巴哈马国',
    iso2: 'bs',
    dialCode: '1242',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Bahrain (‫البحرين‬‎)',
    nameCN: '巴林王国',
    iso2: 'bh',
    dialCode: '973',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Bangladesh (বাংলাদেশ)',
    nameCN: '孟加拉人民共和国',
    iso2: 'bd',
    dialCode: '880',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Barbados',
    nameCN: '巴巴多斯',
    iso2: 'bb',
    dialCode: '1246',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Belarus (Беларусь)',
    nameCN: '白俄罗斯共和国',
    iso2: 'by',
    dialCode: '375',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Belgium (België)',
    nameCN: '比利时王国 (België)',
    iso2: 'be',
    dialCode: '32',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Belize',
    nameCN: '伯利兹',
    iso2: 'bz',
    dialCode: '501',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Benin (Bénin)',
    nameCN: '贝宁共和国 (Bénin)',
    iso2: 'bj',
    dialCode: '229',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Bermuda',
    nameCN: '百慕大群岛',
    iso2: 'bm',
    dialCode: '1441',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Bhutan (འབྲུག)',
    nameCN: '不丹王国',
    iso2: 'bt',
    dialCode: '975',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Bolivia',
    nameCN: '玻利维亚国',
    iso2: 'bo',
    dialCode: '591',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Bosnia and Herzegovina (Босна и Херцеговина)',
    nameCN: '波斯尼亚和黑塞哥维那',
    iso2: 'ba',
    dialCode: '387',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Botswana',
    nameCN: '博茨瓦纳',
    iso2: 'bw',
    dialCode: '267',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Brazil (Brasil)',
    nameCN: '巴西联邦共和国',
    iso2: 'br',
    dialCode: '55',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'British Indian Ocean Territory',
    nameCN: '英属印度洋领地',
    iso2: 'io',
    dialCode: '246',
    priority: 0,
    areaCodes: null,
    pinyin: 'Y',
  },
  {
    name: 'British Virgin Islands',
    nameCN: '英属维尔京群岛',
    iso2: 'vg',
    dialCode: '1284',
    priority: 0,
    areaCodes: null,
    pinyin: 'Y',
  },
  {
    name: 'Brunei',
    nameCN: '文莱达鲁萨兰国',
    iso2: 'bn',
    dialCode: '673',
    priority: 0,
    areaCodes: null,
    pinyin: 'W',
  },
  {
    name: 'Bulgaria (България)',
    nameCN: '保加利亚共和国',
    iso2: 'bg',
    dialCode: '359',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Burkina Faso',
    nameCN: '布基纳法索',
    iso2: 'bf',
    dialCode: '226',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Burundi (Uburundi)',
    nameCN: '布隆迪共和国',
    iso2: 'bi',
    dialCode: '257',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Cambodia (កម្ពុជា)',
    nameCN: '柬埔寨王国',
    iso2: 'kh',
    dialCode: '855',
    priority: 0,
    areaCodes: null,
    pinyin: 'J',
  },
  {
    name: 'Cameroon (Cameroun)',
    nameCN: '喀麦隆共和国',
    iso2: 'cm',
    dialCode: '237',
    priority: 0,
    areaCodes: null,
    pinyin: 'K',
  },
  {
    name: 'Canada',
    nameCN: '加拿大',
    iso2: 'ca',
    dialCode: '1',
    priority: 1,
    areaCodes: [
      '204',
      '226',
      '236',
      '249',
      '250',
      '289',
      '306',
      '343',
      '365',
      '387',
      '403',
      '416',
      '418',
      '431',
      '437',
      '438',
      '450',
      '506',
      '514',
      '519',
      '548',
      '579',
      '581',
      '587',
      '604',
      '613',
      '639',
      '647',
      '672',
      '705',
      '709',
      '742',
      '778',
      '780',
      '782',
      '807',
      '819',
      '825',
      '867',
      '873',
      '902',
      '905',
    ],
    pinyin: 'J',
  },
  {
    name: 'Cape Verde (Kabu Verdi)',
    nameCN: '佛得角共和国',
    iso2: 'cv',
    dialCode: '238',
    priority: 0,
    areaCodes: null,
    pinyin: 'F',
  },
  {
    name: 'Caribbean Netherlands',
    nameCN: '荷兰王国',
    iso2: 'bq',
    dialCode: '599',
    priority: 1,
    areaCodes: null,
    pinyin: 'H',
  },
  {
    name: 'Cayman Islands',
    nameCN: '开曼群岛',
    iso2: 'ky',
    dialCode: '1345',
    priority: 0,
    areaCodes: null,
    pinyin: 'K',
  },
  {
    name: 'Central African Republic (République centrafricaine)',
    nameCN: '中非共和国',
    iso2: 'cf',
    dialCode: '236',
    priority: 0,
    areaCodes: null,
    pinyin: 'Z',
  },
  {
    name: 'Chad (Tchad)',
    nameCN: '乍得共和国',
    iso2: 'td',
    dialCode: '235',
    priority: 0,
    areaCodes: null,
    pinyin: 'Z',
  },
  {
    name: 'Chile',
    nameCN: '智利共和国',
    iso2: 'cl',
    dialCode: '56',
    priority: 0,
    areaCodes: null,
    pinyin: 'Z',
  },

  {
    name: 'Christmas Island',
    nameCN: '圣诞岛',
    iso2: 'cx',
    dialCode: '61',
    priority: 2,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Cocos (Keeling) Islands',
    nameCN: '科科斯群岛',
    iso2: 'cc',
    dialCode: '61',
    priority: 1,
    areaCodes: null,
    pinyin: 'K',
  },
  {
    name: 'Colombia',
    nameCN: '哥伦比亚共和国',
    iso2: 'co',
    dialCode: '57',
    priority: 0,
    areaCodes: null,
    pinyin: 'G',
  },
  {
    name: 'Comoros (‫جزر القمر‬‎)',
    nameCN: '科摩罗联盟',
    iso2: 'km',
    dialCode: '269',
    priority: 0,
    areaCodes: null,
    pinyin: 'K',
  },
  {
    name: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
    nameCN: '刚果民主共和国',
    iso2: 'cd',
    dialCode: '243',
    priority: 0,
    areaCodes: null,
    pinyin: 'G',
  },
  {
    name: 'Congo (Republic) (Congo-Brazzaville)',
    nameCN: '刚果共和国',
    iso2: 'cg',
    dialCode: '242',
    priority: 0,
    areaCodes: null,
    pinyin: 'G',
  },
  {
    name: 'Cook Islands',
    nameCN: '库克群岛',
    iso2: 'ck',
    dialCode: '682',
    priority: 0,
    areaCodes: null,
    pinyin: 'K',
  },
  {
    name: 'Costa Rica',
    nameCN: '哥斯达黎加共和国',
    iso2: 'cr',
    dialCode: '506',
    priority: 0,
    areaCodes: null,
    pinyin: 'G',
  },
  {
    name: 'Côte d’Ivoire',
    nameCN: '科特迪瓦',
    iso2: 'ci',
    dialCode: '225',
    priority: 0,
    areaCodes: null,
    pinyin: 'K',
  },
  {
    name: 'Croatia (Hrvatska)',
    nameCN: '克罗地亚共和国',
    iso2: 'hr',
    dialCode: '385',
    priority: 0,
    areaCodes: null,
    pinyin: 'K',
  },
  {
    name: 'Cuba',
    nameCN: '古巴共和国',
    iso2: 'cu',
    dialCode: '53',
    priority: 0,
    areaCodes: null,
    pinyin: 'G',
  },
  {
    name: 'Curaçao',
    nameCN: '库拉索',
    iso2: 'cw',
    dialCode: '599',
    priority: 0,
    areaCodes: null,
    pinyin: 'K',
  },
  {
    name: 'Cyprus (Κύπρος)',
    nameCN: '塞浦路斯',
    iso2: 'cy',
    dialCode: '357',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Czech Republic (Česká republika)',
    nameCN: '捷克共和国',
    iso2: 'cz',
    dialCode: '420',
    priority: 0,
    areaCodes: null,
    pinyin: 'J',
  },
  {
    name: 'Denmark (Danmark)',
    nameCN: '丹麦',
    iso2: 'dk',
    dialCode: '45',
    priority: 0,
    areaCodes: null,
    pinyin: 'D',
  },
  {
    name: 'Djibouti',
    nameCN: '吉布提共和国',
    iso2: 'dj',
    dialCode: '253',
    priority: 0,
    areaCodes: null,
    pinyin: 'J',
  },
  {
    name: 'Dominica',
    nameCN: '多米尼克国',
    iso2: 'dm',
    dialCode: '1767',
    priority: 0,
    areaCodes: null,
    pinyin: 'D',
  },
  {
    name: 'Dominican Republic (República Dominicana)',
    nameCN: '多米尼加共和国',
    iso2: 'do',
    dialCode: '1',
    priority: 2,
    areaCodes: ['809', '829', '849'],
    pinyin: 'D',
  },
  {
    name: 'Ecuador',
    nameCN: '厄瓜多尔',
    iso2: 'ec',
    dialCode: '593',
    priority: 0,
    areaCodes: null,
    pinyin: 'E',
  },
  {
    name: 'Egypt (‫مصر‬‎)',
    nameCN: '埃及',
    iso2: 'eg',
    dialCode: '20',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'El Salvador',
    nameCN: '萨尔瓦',
    iso2: 'sv',
    dialCode: '503',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Equatorial Guinea (Guinea Ecuatorial)',
    nameCN: '赤道几内亚',
    iso2: 'gq',
    dialCode: '240',
    priority: 0,
    areaCodes: null,
    pinyin: 'C',
  },
  {
    name: 'Eritrea',
    nameCN: '厄立特里亚',
    iso2: 'er',
    dialCode: '291',
    priority: 0,
    areaCodes: null,
    pinyin: 'E',
  },
  {
    name: 'Estonia (Eesti)',
    nameCN: '爱沙尼亚共和国',
    iso2: 'ee',
    dialCode: '372',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Ethiopia',
    nameCN: '埃塞俄比亚',
    iso2: 'et',
    dialCode: '251',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Falkland Islands (Islas Malvinas)',
    nameCN: '马尔维纳斯群岛',
    iso2: 'fk',
    dialCode: '500',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Faroe Islands (Føroyar)',
    nameCN: '法罗群岛',
    iso2: 'fo',
    dialCode: '298',
    priority: 0,
    areaCodes: null,
    pinyin: 'F',
  },
  {
    name: 'Fiji',
    nameCN: '斐济共和国',
    iso2: 'fj',
    dialCode: '679',
    priority: 0,
    areaCodes: null,
    pinyin: 'F',
  },
  {
    name: 'Finland (Suomi)',
    nameCN: '芬兰',
    iso2: 'fi',
    dialCode: '358',
    priority: 0,
    areaCodes: null,
    pinyin: 'F',
  },
  {
    name: 'France',
    nameCN: '法国',
    iso2: 'fr',
    dialCode: '33',
    priority: 0,
    areaCodes: null,
    pinyin: 'F',
  },
  {
    name: 'French Guiana (Guyane française)',
    nameCN: '法属圭亚那',
    iso2: 'gf',
    dialCode: '594',
    priority: 0,
    areaCodes: null,
    pinyin: 'F',
  },
  {
    name: 'French Polynesia (Polynésie française)',
    nameCN: '法属波利尼西亚',
    iso2: 'pf',
    dialCode: '689',
    priority: 0,
    areaCodes: null,
    pinyin: 'F',
  },
  {
    name: 'Gabon',
    nameCN: '加蓬',
    iso2: 'ga',
    dialCode: '241',
    priority: 0,
    areaCodes: null,
    pinyin: 'J',
  },
  {
    name: 'Gambia',
    nameCN: '冈比亚',
    iso2: 'gm',
    dialCode: '220',
    priority: 0,
    areaCodes: null,
    pinyin: 'G',
  },
  {
    name: 'Georgia (საქართველო)',
    nameCN: '格鲁吉亚',
    iso2: 'ge',
    dialCode: '995',
    priority: 0,
    areaCodes: null,
    pinyin: 'G',
  },
  {
    name: 'Germany (Deutschland)',
    nameCN: '德国',
    iso2: 'de',
    dialCode: '49',
    priority: 0,
    areaCodes: null,
    pinyin: 'D',
  },
  {
    name: 'Ghana (Gaana)',
    nameCN: '加纳',
    iso2: 'gh',
    dialCode: '233',
    priority: 0,
    areaCodes: null,
    pinyin: 'J',
  },
  {
    name: 'Gibraltar',
    nameCN: '直布罗陀',
    iso2: 'gi',
    dialCode: '350',
    priority: 0,
    areaCodes: null,
    pinyin: 'Z',
  },
  {
    name: 'Greece (Ελλάδα)',
    nameCN: '希腊',
    iso2: 'gr',
    dialCode: '30',
    priority: 0,
    areaCodes: null,
    pinyin: 'X',
  },
  {
    name: 'Greenland (Kalaallit Nunaat)',
    nameCN: '格陵兰',
    iso2: 'gl',
    dialCode: '299',
    priority: 0,
    areaCodes: null,
    pinyin: 'G',
  },
  {
    name: 'Grenada',
    nameCN: '格林纳达',
    iso2: 'gd',
    dialCode: '1473',
    priority: 0,
    areaCodes: null,
    pinyin: 'G',
  },
  {
    name: 'Guadeloupe',
    nameCN: '瓜德罗普岛',
    iso2: 'gp',
    dialCode: '590',
    priority: 0,
    areaCodes: null,
    pinyin: 'G',
  },
  {
    name: 'Guam',
    nameCN: '关岛',
    iso2: 'gu',
    dialCode: '1671',
    priority: 0,
    areaCodes: null,
    pinyin: 'G',
  },
  {
    name: 'Guatemala',
    nameCN: '危地马拉',
    iso2: 'gt',
    dialCode: '502',
    priority: 0,
    areaCodes: null,
    pinyin: 'W',
  },
  {
    name: 'Guernsey',
    nameCN: '根西',
    iso2: 'gg',
    dialCode: '44',
    priority: 1,
    areaCodes: null,
    pinyin: 'G',
  },
  {
    name: 'Guinea (Guinée)',
    nameCN: '几内亚',
    iso2: 'gn',
    dialCode: '224',
    priority: 0,
    areaCodes: null,
    pinyin: 'J',
  },
  {
    name: 'Guinea-Bissau (Guiné Bissau)',
    nameCN: '几内亚比绍共和国',
    iso2: 'gw',
    dialCode: '245',
    priority: 0,
    areaCodes: null,
    pinyin: 'J',
  },
  {
    name: 'Guyana',
    nameCN: '圭亚那',
    iso2: 'gy',
    dialCode: '592',
    priority: 0,
    areaCodes: null,
    pinyin: 'G',
  },
  {
    name: 'Haiti',
    nameCN: '海地',
    iso2: 'ht',
    dialCode: '509',
    priority: 0,
    areaCodes: null,
    pinyin: 'H',
  },
  {
    name: 'Honduras',
    nameCN: '洪都拉斯',
    iso2: 'hn',
    dialCode: '504',
    priority: 0,
    areaCodes: null,
    pinyin: 'H',
  },

  {
    name: 'Hungary (Magyarország)',
    nameCN: '匈牙利',
    iso2: 'hu',
    dialCode: '36',
    priority: 0,
    areaCodes: null,
    pinyin: 'X',
  },
  {
    name: 'Iceland (Ísland)',
    nameCN: '冰岛',
    iso2: 'is',
    dialCode: '354',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'India (भारत)',
    nameCN: '印度',
    iso2: 'in',
    dialCode: '91',
    priority: 0,
    areaCodes: null,
    pinyin: 'Y',
  },
  {
    name: 'Indonesia',
    nameCN: '印度尼西亚',
    iso2: 'id',
    dialCode: '62',
    priority: 0,
    areaCodes: null,
    pinyin: 'Y',
  },
  {
    name: 'Iran (‫ایران‬‎)',
    nameCN: '地拉那',
    iso2: 'ir',
    dialCode: '98',
    priority: 0,
    areaCodes: null,
    pinyin: 'D',
  },
  {
    name: 'Iraq (‫العراق‬‎)',
    nameCN: '伊拉克共和国',
    iso2: 'iq',
    dialCode: '964',
    priority: 0,
    areaCodes: null,
    pinyin: 'Y',
  },
  {
    name: 'Ireland',
    nameCN: '爱尔兰',
    iso2: 'ie',
    dialCode: '353',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Isle of Man',
    nameCN: '马恩岛',
    iso2: 'im',
    dialCode: '44',
    priority: 2,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Israel (‫ישראל‬‎)',
    nameCN: '以色列国',
    iso2: 'il',
    dialCode: '972',
    priority: 0,
    areaCodes: null,
    pinyin: 'Y',
  },
  {
    name: 'Italy (Italia)',
    nameCN: '意大利',
    iso2: 'it',
    dialCode: '39',
    priority: 0,
    areaCodes: null,
    pinyin: 'Y',
  },
  {
    name: 'Jamaica',
    nameCN: '牙买加',
    iso2: 'jm',
    dialCode: '1',
    priority: 4,
    areaCodes: ['876', '658'],
    pinyin: 'Y',
  },
  {
    name: 'Japan (日本)',
    nameCN: '日本',
    iso2: 'jp',
    dialCode: '81',
    priority: 0,
    areaCodes: null,
    pinyin: 'R',
  },
  {
    name: 'Jersey',
    nameCN: '泽西',
    iso2: 'je',
    dialCode: '44',
    priority: 3,
    areaCodes: null,
    pinyin: 'Z',
  },
  {
    name: 'Jordan (‫الأردن‬‎)',
    nameCN: '约旦哈希姆王国',
    iso2: 'jo',
    dialCode: '962',
    priority: 0,
    areaCodes: null,
    pinyin: 'Y',
  },
  {
    name: 'Kazakhstan (Казахстан)',
    nameCN: '哈萨克斯坦共和国',
    iso2: 'kz',
    dialCode: '7',
    priority: 1,
    areaCodes: null,
    pinyin: 'H',
  },
  {
    name: 'Kenya',
    nameCN: '肯尼亚',
    iso2: 'ke',
    dialCode: '254',
    priority: 0,
    areaCodes: null,
    pinyin: 'K',
  },
  {
    name: 'Kiribati',
    nameCN: '基里巴斯',
    iso2: 'ki',
    dialCode: '686',
    priority: 0,
    areaCodes: null,
    pinyin: 'J',
  },
  {
    name: 'Kosovo',
    nameCN: '科索沃',
    iso2: 'xk',
    dialCode: '383',
    priority: 0,
    areaCodes: null,
    pinyin: 'K',
  },
  {
    name: 'Kuwait (‫الكويت‬‎)',
    nameCN: '科威特国',
    iso2: 'kw',
    dialCode: '965',
    priority: 0,
    areaCodes: null,
    pinyin: 'K',
  },
  {
    name: 'Kyrgyzstan (Кыргызстан)',
    nameCN: '吉尔吉斯共和国',
    iso2: 'kg',
    dialCode: '996',
    priority: 0,
    areaCodes: null,
    pinyin: 'J',
  },
  {
    name: 'Laos (ລາວ)',
    nameCN: '老挝人民民主共和国',
    iso2: 'la',
    dialCode: '856',
    priority: 0,
    areaCodes: null,
    pinyin: 'L',
  },
  {
    name: 'Latvia (Latvija)',
    nameCN: '拉脱维亚共和国',
    iso2: 'lv',
    dialCode: '371',
    priority: 0,
    areaCodes: null,
    pinyin: 'L',
  },
  {
    name: 'Lebanon (‫لبنان‬‎)',
    nameCN: '黎巴嫩共和国',
    iso2: 'lb',
    dialCode: '961',
    priority: 0,
    areaCodes: null,
    pinyin: 'L',
  },
  {
    name: 'Lesotho',
    nameCN: '莱索托',
    iso2: 'ls',
    dialCode: '266',
    priority: 0,
    areaCodes: null,
    pinyin: 'L',
  },
  {
    name: 'Liberia',
    nameCN: '利比里亚',
    iso2: 'lr',
    dialCode: '231',
    priority: 0,
    areaCodes: null,
    pinyin: 'L',
  },
  {
    name: 'Libya (‫ليبيا‬‎)',
    nameCN: '利比亚',
    iso2: 'ly',
    dialCode: '218',
    priority: 0,
    areaCodes: null,
    pinyin: 'L',
  },
  {
    name: 'Liechtenstein',
    nameCN: '列支敦士登',
    iso2: 'li',
    dialCode: '423',
    priority: 0,
    areaCodes: null,
    pinyin: 'L',
  },
  {
    name: 'Lithuania (Lietuva)',
    nameCN: '立陶宛共和国',
    iso2: 'lt',
    dialCode: '370',
    priority: 0,
    areaCodes: null,
    pinyin: 'L',
  },
  {
    name: 'Luxembourg',
    nameCN: '卢森堡',
    iso2: 'lu',
    dialCode: '352',
    priority: 0,
    areaCodes: null,
    pinyin: 'L',
  },
  {
    name: 'Macedonia (FYROM) (Македонија)',
    nameCN: '马其顿',
    iso2: 'mk',
    dialCode: '389',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Madagascar (Madagasikara)',
    nameCN: '马达加斯加共和国',
    iso2: 'mg',
    dialCode: '261',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Malawi',
    nameCN: '马拉维',
    iso2: 'mw',
    dialCode: '265',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Malaysia',
    nameCN: '马来西亚',
    iso2: 'my',
    dialCode: '60',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Maldives',
    nameCN: '马尔代夫',
    iso2: 'mv',
    dialCode: '960',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Mali',
    nameCN: '马里',
    iso2: 'ml',
    dialCode: '223',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Malta',
    nameCN: '马耳他',
    iso2: 'mt',
    dialCode: '356',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Marshall Islands',
    nameCN: '马绍尔群岛共和国',
    iso2: 'mh',
    dialCode: '692',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Martinique',
    nameCN: '马提尼克岛',
    iso2: 'mq',
    dialCode: '596',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Mauritania (‫موريتانيا‬‎)',
    nameCN: '毛里塔尼亚',
    iso2: 'mr',
    dialCode: '222',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Mauritius (Moris)',
    nameCN: '毛里求斯',
    iso2: 'mu',
    dialCode: '230',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Mayotte',
    nameCN: '马约特',
    iso2: 'yt',
    dialCode: '262',
    priority: 1,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Mexico (México)',
    nameCN: '墨西哥',
    iso2: 'mx',
    dialCode: '52',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Micronesia',
    nameCN: '密克罗尼西亚',
    iso2: 'fm',
    dialCode: '691',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Moldova (Republica Moldova)',
    nameCN: '摩尔多瓦共和国',
    iso2: 'md',
    dialCode: '373',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Monaco',
    nameCN: '摩纳哥',
    iso2: 'mc',
    dialCode: '377',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Mongolia (Монгол)',
    nameCN: '蒙古',
    iso2: 'mn',
    dialCode: '976',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Montenegro (Crna Gora)',
    nameCN: '黑山共和国',
    iso2: 'me',
    dialCode: '382',
    priority: 0,
    areaCodes: null,
    pinyin: 'H',
  },
  {
    name: 'Montserrat',
    nameCN: '蒙特塞拉特岛',
    iso2: 'ms',
    dialCode: '1664',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Morocco (‫المغرب‬‎)',
    nameCN: '摩洛哥',
    iso2: 'ma',
    dialCode: '212',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Mozambique (Moçambique)',
    nameCN: '莫桑比克',
    iso2: 'mz',
    dialCode: '258',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Myanmar (Burma) (မြန်မာ)',
    nameCN: '缅甸联邦共和国',
    iso2: 'mm',
    dialCode: '95',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Namibia (Namibië)',
    nameCN: '纳米比亚',
    iso2: 'na',
    dialCode: '264',
    priority: 0,
    areaCodes: null,
    pinyin: 'N',
  },
  {
    name: 'Nauru',
    nameCN: '瑙鲁',
    iso2: 'nr',
    dialCode: '674',
    priority: 0,
    areaCodes: null,
    pinyin: 'N',
  },
  {
    name: 'Nepal (नेपाल)',
    nameCN: '尼泊尔',
    iso2: 'np',
    dialCode: '977',
    priority: 0,
    areaCodes: null,
    pinyin: 'N',
  },
  {
    name: 'Netherlands (Nederland)',
    nameCN: '荷兰',
    iso2: 'nl',
    dialCode: '31',
    priority: 0,
    areaCodes: null,
    pinyin: 'H',
  },
  {
    name: 'New Caledonia (Nouvelle-Calédonie)',
    nameCN: '新喀里多尼亚',
    iso2: 'nc',
    dialCode: '687',
    priority: 0,
    areaCodes: null,
    pinyin: 'X',
  },
  {
    name: 'New Zealand',
    nameCN: '新西兰',
    iso2: 'nz',
    dialCode: '64',
    priority: 0,
    areaCodes: null,
    pinyin: 'X',
  },
  {
    name: 'Nicaragua',
    nameCN: '尼加拉瓜',
    iso2: 'ni',
    dialCode: '505',
    priority: 0,
    areaCodes: null,
    pinyin: 'N',
  },
  {
    name: 'Niger (Nijar)',
    nameCN: '尼日尔',
    iso2: 'ne',
    dialCode: '227',
    priority: 0,
    areaCodes: null,
    pinyin: 'N',
  },
  {
    name: 'Nigeria',
    nameCN: '尼日利亚',
    iso2: 'ng',
    dialCode: '234',
    priority: 0,
    areaCodes: null,
    pinyin: 'N',
  },
  {
    name: 'Niue',
    nameCN: '纽埃',
    iso2: 'nu',
    dialCode: '683',
    priority: 0,
    areaCodes: null,
    pinyin: 'N',
  },
  {
    name: 'Norfolk Island',
    nameCN: '诺福克岛',
    iso2: 'nf',
    dialCode: '672',
    priority: 0,
    areaCodes: null,
    pinyin: 'N',
  },
  {
    name: 'North Korea (조선 민주주의 인민 공화국)',
    nameCN: '朝鲜',
    iso2: 'kp',
    dialCode: '850',
    priority: 0,
    areaCodes: null,
    pinyin: 'C',
  },
  {
    name: 'Northern Mariana Islands',
    nameCN: '北马里亚纳群岛',
    iso2: 'mp',
    dialCode: '1670',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Norway (Norge)',
    nameCN: '挪威',
    iso2: 'no',
    dialCode: '47',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Oman (‫عُمان‬‎)',
    nameCN: '阿曼苏丹国',
    iso2: 'om',
    dialCode: '968',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Pakistan (‫پاکستان‬‎)',
    nameCN: '巴基斯坦',
    iso2: 'pk',
    dialCode: '92',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Palau',
    nameCN: '帕劳共和国',
    iso2: 'pw',
    dialCode: '680',
    priority: 0,
    areaCodes: null,
    pinyin: 'P',
  },
  {
    name: 'Palestine (‫فلسطين‬‎)',
    nameCN: '巴勒斯坦国',
    iso2: 'ps',
    dialCode: '970',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Panama (Panamá)',
    nameCN: '巴拿马',
    iso2: 'pa',
    dialCode: '507',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Papua New Guinea',
    nameCN: '巴布亚新几内亚独立国',
    iso2: 'pg',
    dialCode: '675',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Paraguay',
    nameCN: '巴拉圭',
    iso2: 'py',
    dialCode: '595',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Peru (Perú)',
    nameCN: '秘鲁',
    iso2: 'pe',
    dialCode: '51',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Philippines',
    nameCN: '菲律宾共和国',
    iso2: 'ph',
    dialCode: '63',
    priority: 0,
    areaCodes: null,
    pinyin: 'F',
  },
  {
    name: 'Poland (Polska)',
    nameCN: '波兰',
    iso2: 'pl',
    dialCode: '48',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'Portugal',
    nameCN: '葡萄牙',
    iso2: 'pt',
    dialCode: '351',
    priority: 0,
    areaCodes: null,
    pinyin: 'P',
  },
  {
    name: 'Puerto Rico',
    nameCN: '波多黎各岛',
    iso2: 'pr',
    dialCode: '1',
    priority: 3,
    areaCodes: ['787', '939'],
    pinyin: 'B',
  },
  {
    name: 'Qatar (‫قطر‬‎)',
    nameCN: '卡塔尔国',
    iso2: 'qa',
    dialCode: '974',
    priority: 0,
    areaCodes: null,
    pinyin: 'K',
  },
  {
    name: 'Réunion (La Réunion)',
    nameCN: '留尼旺岛',
    iso2: 're',
    dialCode: '262',
    priority: 0,
    areaCodes: null,
    pinyin: 'L',
  },
  {
    name: 'Romania (România)',
    nameCN: '罗马尼亚',
    iso2: 'ro',
    dialCode: '40',
    priority: 0,
    areaCodes: null,
    pinyin: 'L',
  },
  {
    name: 'Russia (Россия)',
    nameCN: '俄罗斯',
    iso2: 'ru',
    dialCode: '7',
    priority: 0,
    areaCodes: null,
    pinyin: 'E',
  },
  {
    name: 'Rwanda',
    nameCN: '卢旺达',
    iso2: 'rw',
    dialCode: '250',
    priority: 0,
    areaCodes: null,
    pinyin: 'L',
  },
  {
    name: 'Saint Barthélemy',
    nameCN: '圣巴托洛缪岛',
    iso2: 'bl',
    dialCode: '590',
    priority: 1,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Saint Helena',
    nameCN: '圣海伦娜岛',
    iso2: 'sh',
    dialCode: '290',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Saint Kitts and Nevis',
    nameCN: '圣基茨和尼维斯联邦',
    iso2: 'kn',
    dialCode: '1869',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Saint Lucia',
    nameCN: '圣卢西亚',
    iso2: 'lc',
    dialCode: '1758',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Saint Martin (Saint-Martin (partie française))',
    nameCN: '圣马丁岛',
    iso2: 'mf',
    dialCode: '590',
    priority: 2,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
    nameCN: '圣皮埃尔岛和密克隆岛',
    iso2: 'pm',
    dialCode: '508',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    nameCN: '圣文森特和格林纳丁斯',
    iso2: 'vc',
    dialCode: '1784',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Samoa',
    nameCN: '西萨摩亚',
    iso2: 'ws',
    dialCode: '685',
    priority: 0,
    areaCodes: null,
    pinyin: 'X',
  },
  {
    name: 'San Marino',
    nameCN: '圣马利诺',
    iso2: 'sm',
    dialCode: '378',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'São Tomé and Príncipe (São Tomé e Príncipe)',
    nameCN: '圣多美普林西比',
    iso2: 'st',
    dialCode: '239',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
    nameCN: '沙特阿拉伯王国',
    iso2: 'sa',
    dialCode: '966',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Senegal (Sénégal)',
    nameCN: '塞内加尔',
    iso2: 'sn',
    dialCode: '221',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Serbia (Србија)',
    nameCN: '塞尔维亚共和国',
    iso2: 'rs',
    dialCode: '381',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Seychelles',
    nameCN: '塞舌尔',
    iso2: 'sc',
    dialCode: '248',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Sierra Leone',
    nameCN: '塞拉利昂共和国',
    iso2: 'sl',
    dialCode: '232',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Singapore',
    nameCN: '新加坡',
    iso2: 'sg',
    dialCode: '65',
    priority: 0,
    areaCodes: null,
    pinyin: 'X',
  },
  {
    name: 'Sint Maarten',
    nameCN: '圣马丁岛',
    iso2: 'sx',
    dialCode: '1721',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Slovakia (Slovensko)',
    nameCN: '斯洛伐克共和国',
    iso2: 'sk',
    dialCode: '421',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Slovenia (Slovenija)',
    nameCN: '斯洛文尼亚',
    iso2: 'si',
    dialCode: '386',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Solomon Islands',
    nameCN: '所罗门群岛',
    iso2: 'sb',
    dialCode: '677',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Somalia (Soomaaliya)',
    nameCN: '索马里',
    iso2: 'so',
    dialCode: '252',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'South Africa',
    nameCN: '南非',
    iso2: 'za',
    dialCode: '27',
    priority: 0,
    areaCodes: null,
    pinyin: 'N',
  },
  {
    name: 'South Korea (대한민국)',
    nameCN: '韩国',
    iso2: 'kr',
    dialCode: '82',
    priority: 0,
    areaCodes: null,
    pinyin: 'H',
  },
  {
    name: 'South Sudan (‫جنوب السودان‬‎)',
    nameCN: '南苏丹共和国',
    iso2: 'ss',
    dialCode: '211',
    priority: 0,
    areaCodes: null,
    pinyin: 'N',
  },
  {
    name: 'Spain (España)',
    nameCN: '西班牙',
    iso2: 'es',
    dialCode: '34',
    priority: 0,
    areaCodes: null,
    pinyin: 'X',
  },
  {
    name: 'Sri Lanka (ශ්‍රී ලංකාව)',
    nameCN: '斯里兰卡',
    iso2: 'lk',
    dialCode: '94',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Sudan (‫السودان‬‎)',
    nameCN: '苏丹',
    iso2: 'sd',
    dialCode: '249',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Suriname',
    nameCN: '苏里南',
    iso2: 'sr',
    dialCode: '597',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Svalbard and Jan Mayen',
    nameCN: '斯瓦尔巴群岛',
    iso2: 'sj',
    dialCode: '47',
    priority: 1,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Swaziland',
    nameCN: '斯威士兰',
    iso2: 'sz',
    dialCode: '268',
    priority: 0,
    areaCodes: null,
    pinyin: 'S',
  },
  {
    name: 'Sweden (Sverige)',
    nameCN: '瑞典',
    iso2: 'se',
    dialCode: '46',
    priority: 0,
    areaCodes: null,
    pinyin: 'R',
  },
  {
    name: 'Switzerland (Schweiz)',
    nameCN: '瑞士',
    iso2: 'ch',
    dialCode: '41',
    priority: 0,
    areaCodes: null,
    pinyin: 'R',
  },
  {
    name: 'Syria (‫سوريا‬‎)',
    nameCN: '阿拉伯叙利亚共和国',
    iso2: 'sy',
    dialCode: '963',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },

  {
    name: 'Tajikistan',
    nameCN: '塔吉克斯坦共和国',
    iso2: 'tj',
    dialCode: '992',
    priority: 0,
    areaCodes: null,
    pinyin: 'T',
  },
  {
    name: 'Tanzania',
    nameCN: '坦桑尼亚',
    iso2: 'tz',
    dialCode: '255',
    priority: 0,
    areaCodes: null,
    pinyin: 'T',
  },
  {
    name: 'Thailand (ไทย)',
    nameCN: '泰国',
    iso2: 'th',
    dialCode: '66',
    priority: 0,
    areaCodes: null,
    pinyin: 'T',
  },
  {
    name: 'Timor-Leste',
    nameCN: '东帝汶民主共和国',
    iso2: 'tl',
    dialCode: '670',
    priority: 0,
    areaCodes: null,
    pinyin: 'D',
  },
  {
    name: 'Togo',
    nameCN: '多哥',
    iso2: 'tg',
    dialCode: '228',
    priority: 0,
    areaCodes: null,
    pinyin: 'D',
  },
  {
    name: 'Tokelau',
    nameCN: '托克劳群岛',
    iso2: 'tk',
    dialCode: '690',
    priority: 0,
    areaCodes: null,
    pinyin: 'T',
  },
  {
    name: 'Tonga',
    nameCN: '汤加',
    iso2: 'to',
    dialCode: '676',
    priority: 0,
    areaCodes: null,
    pinyin: 'T',
  },
  {
    name: 'Trinidad and Tobago',
    nameCN: '特立尼达和多巴哥共和国',
    iso2: 'tt',
    dialCode: '1868',
    priority: 0,
    areaCodes: null,
    pinyin: 'T',
  },
  {
    name: 'Tunisia (‫تونس‬‎)',
    nameCN: '突尼斯',
    iso2: 'tn',
    dialCode: '216',
    priority: 0,
    areaCodes: null,
    pinyin: 'T',
  },
  {
    name: 'Turkey (Türkiye)',
    nameCN: '土耳其',
    iso2: 'tr',
    dialCode: '90',
    priority: 0,
    areaCodes: null,
    pinyin: 'T',
  },
  {
    name: 'Turkmenistan',
    nameCN: '土库曼斯坦',
    iso2: 'tm',
    dialCode: '993',
    priority: 0,
    areaCodes: null,
    pinyin: 'T',
  },
  {
    name: 'Turks and Caicos Islands',
    nameCN: '特克斯和凯科斯群岛',
    iso2: 'tc',
    dialCode: '1649',
    priority: 0,
    areaCodes: null,
    pinyin: 'T',
  },
  {
    name: 'Tuvalu',
    nameCN: '图瓦卢',
    iso2: 'tv',
    dialCode: '688',
    priority: 0,
    areaCodes: null,
    pinyin: 'T',
  },
  {
    name: 'U.S. Virgin Islands',
    nameCN: '美属维尔京群岛',
    iso2: 'vi',
    dialCode: '1340',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Uganda',
    nameCN: '乌干达共和国',
    iso2: 'ug',
    dialCode: '256',
    priority: 0,
    areaCodes: null,
    pinyin: 'W',
  },
  {
    name: 'Ukraine (Україна)',
    nameCN: '乌克兰',
    iso2: 'ua',
    dialCode: '380',
    priority: 0,
    areaCodes: null,
    pinyin: 'W',
  },
  {
    name: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
    nameCN: '阿拉伯联合酋长国',
    iso2: 'ae',
    dialCode: '971',
    priority: 0,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'United Kingdom',
    nameCN: '大不列颠联合王国',
    iso2: 'gb',
    dialCode: '44',
    priority: 0,
    areaCodes: null,
    pinyin: 'D',
  },
  {
    name: 'United States',
    nameCN: '美国',
    iso2: 'us',
    dialCode: '1',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
  {
    name: 'Uruguay',
    nameCN: '乌拉圭',
    iso2: 'uy',
    dialCode: '598',
    priority: 0,
    areaCodes: null,
    pinyin: 'W',
  },
  {
    name: 'Uzbekistan (Oʻzbekiston)',
    nameCN: '乌兹别克斯坦共和国',
    iso2: 'uz',
    dialCode: '998',
    priority: 0,
    areaCodes: null,
    pinyin: 'W',
  },
  {
    name: 'Vanuatu',
    nameCN: '瓦努阿图',
    iso2: 'vu',
    dialCode: '678',
    priority: 0,
    areaCodes: null,
    pinyin: 'W',
  },
  {
    name: 'Vatican City (Città del Vaticano)',
    nameCN: '梵蒂冈',
    iso2: 'va',
    dialCode: '39',
    priority: 1,
    areaCodes: null,
    pinyin: 'F',
  },
  {
    name: 'Venezuela',
    nameCN: '委内瑞拉',
    iso2: 've',
    dialCode: '58',
    priority: 0,
    areaCodes: null,
    pinyin: 'W',
  },
  {
    name: 'Vietnam (Việt Nam)',
    nameCN: '越南',
    iso2: 'vn',
    dialCode: '84',
    priority: 0,
    areaCodes: null,
    pinyin: 'Y',
  },
  {
    name: 'Wallis and Futuna (Wallis-et-Futuna)',
    nameCN: '瓦利斯群岛和富图纳群岛',
    iso2: 'wf',
    dialCode: '681',
    priority: 0,
    areaCodes: null,
    pinyin: 'W',
  },
  {
    name: 'Western Sahara (‫الصحراء الغربية‬‎)',
    nameCN: '阿拉伯撒哈拉民主共和国',
    iso2: 'eh',
    dialCode: '212',
    priority: 1,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Yemen (‫اليمن‬‎)',
    nameCN: '也门共和国',
    iso2: 'ye',
    dialCode: '967',
    priority: 0,
    areaCodes: null,
    pinyin: 'Y',
  },
  {
    name: 'Zambia',
    nameCN: '赞比亚',
    iso2: 'zm',
    dialCode: '260',
    priority: 0,
    areaCodes: null,
    pinyin: 'Z',
  },
  {
    name: 'Zimbabwe',
    nameCN: '津巴布韦',
    iso2: 'zw',
    dialCode: '263',
    priority: 0,
    areaCodes: null,
    pinyin: 'J',
  },
  {
    name: 'Åland Islands',
    nameCN: '奥兰群岛',
    iso2: 'ax',
    dialCode: '358',
    priority: 1,
    areaCodes: null,
    pinyin: 'A',
  },
  {
    name: 'Antarctica',
    nameCN: '南极洲',
    iso2: 'aq',
    dialCode: '672',
    priority: 0,
    areaCodes: null,
    pinyin: 'N',
  },
  {
    name: 'Bouvet Island',
    nameCN: '布维岛',
    iso2: 'bv',
    dialCode: '47',
    priority: 0,
    areaCodes: null,
    pinyin: 'B',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    nameCN: '南乔治亚和南桑威奇群岛',
    iso2: 'gs',
    dialCode: '500',
    priority: 0,
    areaCodes: null,
    pinyin: 'N',
  },
  {
    name: 'Heard Island and McDonald Islands',
    nameCN: '赫德岛和麦克唐纳群岛',
    iso2: 'hm',
    dialCode: '672',
    priority: 0,
    areaCodes: null,
    pinyin: 'H',
  },
  {
    name: 'Pitcairn',
    nameCN: '皮特凯恩群岛',
    iso2: 'pn',
    dialCode: '64',
    priority: 0,
    areaCodes: null,
    pinyin: 'P',
  },
  {
    name: 'French Southern Territories',
    nameCN: '法属南部和南极领地',
    iso2: 'tf',
    dialCode: '262',
    priority: 0,
    areaCodes: null,
    pinyin: 'F',
  },
  {
    name: 'United States Minor Outlying Islands',
    nameCN: '美国本土外小岛屿',
    iso2: 'um',
    dialCode: '1',
    priority: 0,
    areaCodes: null,
    pinyin: 'M',
  },
];
